import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CaseTreatment } from "../_types/case-treatment";

@Injectable({
    providedIn: 'root',
})
export class CasesTreatmentsService extends Service<CaseTreatment> {
    public override type = 'caseTreatments';
    public override url = 'attendance/caseTreatments';
    
    //habilita la cache para el metodo all
    public override CACHEABLE_METHODS: any = { all: true };
}
